<div class="reservation-picker-dialog">
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>autorenew</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Use a reserved number?</h2>
      <p class="dialog-subtitle">Released from a cancelled record — the number stays, the date just updates</p>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    @if (isLoading) {
      <div class="picker-loading">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    } @else if (reservations.length === 0) {
      <div class="picker-empty">
        <mat-icon>inbox</mat-icon>
        <p>No reserved numbers available right now.</p>
        <span>A fresh number will be generated as usual.</span>
      </div>
    } @else {
      <div class="reservation-list">
        @for (reservation of reservations; track reservation.id) {
          <button type="button" class="reservation-row" (click)="pick(reservation)">
            <span class="reservation-main">
              <b>{{ displayNumber(reservation) }}</b>
              @if (reservation.preview_number) {
                <span class="reservation-sub">Counter {{ reservation.counter_value }} reused — this is what the new number will actually be</span>
              } @else {
                <span class="reservation-sub">Counter {{ reservation.counter_value }} reused — Year and Sales Rep Code update automatically</span>
              }
            </span>
            <mat-icon class="reservation-arrow">chevron_right</mat-icon>
          </button>
        }
      </div>
    }
  </div>

  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Skip — use a new number
    </button>
  </div>
</div>
